module.exports = __webpack_public_path__ + "media/images/add-card-d3775a5b7c5a7dd361e85e0485d55ad3.svg";